<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <!-- 复合日期搜索框 -->
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSearchChange">
        </CompositeFormDate>
      </template>
      <template #beforeBtn>
        <CompositeFormCtrl ref="comFormCtrl" :options="searchKeyOptions" @onChange="onComSearchChange">
        </CompositeFormCtrl>
      </template>
    </SearchField>

    <Table ref="table" :tableHeight="tableHeight" :tableData="tableData" :cols="cols" :page="page" :limit="limit"
      :total="total" :showIndex="true" :btns="btns" @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template #orderNum="params">
        <div class="orderNum" :class="params.params.is_reject == 1 ? 'tui' : ''">
          {{ params.params.order_num }}
        </div>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";
import mixin from "../mixin";

export default {
  mixins: [tableMixin, mixin],
  data() {
    return {
      baseUrl: 'contract',
      getListUrl: 'orderec',
      formInline: {
        ischeck: 1,
        isstatus: 3,
      },
      formCtrl: [],
      cols: [
        { prop: "order_num", label: "订单编号", width: 200, slot: 'orderNum' },
        { prop: "fleet_nickname", label: "车队长" },
        { prop: "license", label: "车牌号", minwidth: 120 },
        { prop: "driver", label: "司机" },
        { prop: "shname", label: "客户名称" },
        { prop: "coaddress", label: "装货地址" },
        { prop: "enaddress", label: "卸货地址" },
        { prop: "starttime", label: "装货日期", width: 120 },
        { prop: "inton", label: "装货重量", align: 'right', className: 'pr30', width: 120 },
        { prop: "unton", label: "卸货重量", align: 'right', className: 'pr30', width: 120 },
      ],
      btns: [
        {
          ...this.feeBtn,
          cb: ({ id, isstatus }) => {
            console.log(id)
            let mode = 'view'
            if ([3, 4].includes(isstatus) && [5].includes(this.user.user_group_id) || (this.user.id == 1)) {
              mode = 'edit'
            }
            this.$router.push(
              `/order/contractfee?id=${id}&mode=${mode}`
            );
          },
        },
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/order/contractview3?id=${id}&mode=view`
            );
          },
        },
      ],
    };
  },
  methods: {},
  mounted() {
    const { user_group_id, id } = this.user
    if ([1].includes(user_group_id) && id == 1) {
      this.btns.push({
        ...this.delBtn,
        cb: ({ order_num }) => {
          this.delete(order_num)
        },
      })
    }
    if ([1, 2, 3, 4].includes(user_group_id)) {
      this.btns[1] = {
        ...this.editBtn,
        cb: ({ id, isstatus, isover }) => {
          console.log(id, isstatus)
          let path = 'contractview'
          let mode = 'view'
          if (isstatus == 4) {
            path = 'contractview4'
            mode = 'edit'
          } else if (isstatus == 3 && isover == 2) {
            path = 'contractview5'
            mode = 'edit'
          }
          this.$router.push(
            `/order/${path}?id=${id}&mode=${mode}`
          );
        },
      }
    }
  },
};
</script>

<style lang="less" scoped>
.main {
  /deep/ .table-wrap {
    .el-table {
      .orderNum {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .tui {
        position: relative;

        &::after {
          content: '';
          display: inline-block;
          width: 20px;
          height: 20px;
          background: url(../../../../../assets/img/icon_reject.png) no-repeat center center;
          background-size: 20px;
        }
      }
    }
  }
}
</style>
